import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import styled from "styled-components";
import { useEffect, useState } from "react";

type Props = {
  data: ChartData[];
  colorIndex: number;
};

interface ChartData {
  name: string;
  value: number;
  //remain: number;
}

const backgroundColors = [
  "#4f46e5",
  "#0ea5e9",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#f43f5e",
];

function StackBarChart({ data, colorIndex }: Props) {
  const [chartDataList, setChartDataList] = useState<ChartData[]>([]);
  const [maxValue, setMaxValue] = useState<number>(0);

  useEffect(() => {
    setChartDataList(data);
    setMaxValue(Math.max(...data.map((item) => item.value)));
  }, [data]);

  return (
    <Container>
      <ResponsiveContainer height={200} width="100%">
        <BarChart
          // layout="horizontal"
          data={chartDataList}
          margin={{ left: 0, right: 0, top: 0, bottom: 0 }}
          //stackOffset="expand"
        >
          <XAxis
            type="category"
            dataKey="name"
            stroke="#000"
            fontSize="12"
            textAnchor="start"
            width={40}
            height={50}
            angle={90}
            tickMargin={10}
            tickLine={false}
            rotate={-90}
          />
          <YAxis type="number" domain={[0, maxValue]} />
          <Tooltip />
          <Bar
            className="bar"
            dataKey="value"
            fill={backgroundColors[colorIndex]}
            stroke="#000"
            strokeWidth={0.4}
            stackId="a"
            width={10}
            label="영업"
          />
          {/* <Bar
            className="bar"
            dataKey="remain"
            fill="#eee"
            stroke="#000"
            strokeWidth={0.4}
            stackId="a"
            width={10}
            label="남은양"
          /> */}
        </BarChart>
      </ResponsiveContainer>
    </Container>
  );
}

const Container = styled.div`
  padding-bottom: 20px;
`;

export default StackBarChart;
